<template>
  <div>
    <!-- <v-btn
        v-if="$admin.can('md-makes.create')"
        color="primary"
        dark
        @click="openModal"
      >
        {{ $t("add_new") }}
      </v-btn> -->
    <!-- v-if="isVisibleDialog" -->
    <v-dialog
      v-model="isVisibleDialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="$admin.can('tenant-configurations.create')"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          @click="openModal"
        >
          {{ $t("add_new") }}
        </v-btn>
      </template>

      <v-form
        ref="form"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="text-h3">{{ $t("add_new") }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  v-if="authUser.isAdmin"
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="item.parent_tenant"
                    dense
                    :disabled="tenantLoading"
                    :loading="tenantLoading"
                    :items="tenantsList"
                    item-text="name"
                    item-value="id"
                    :label="$t('select_parent_tenant_*')"
                    clearable
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="item.child_tenant"
                    dense
                    :disabled="tenantLoading"
                    :loading="tenantLoading"
                    :items="
                      tenantsList.filter((r) => r.id !== item.parent_tenant)
                    "
                    item-text="name"
                    item-value="id"
                    :label="$t('select_child_tenant_*')"
                    clearable
                    :rules="[rules.required]"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <small>{{ $t("indicates_required_field") }}</small>
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              @click="closeForm()"
            >
              Close
            </v-btn>
            <v-btn
              color="primary"
              text
              :loading="isLoading"
              @click="saveItem(item)"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { validationRules } from "@/mixins/validationRules";

export default {
  mixins: [validationRules],
  props: {
    filterOptions: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isVisibleDialog: false,
      item: {},
    };
  },

  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "tenantsRelationship/getLoading",
      tenantLoading: "tenantsManagement/getIsLoading",
      tenantsList: "tenantsManagement/getTenantOptions",
      //
    }),
  },

  // async mounted() {},

  methods: {
    openModal() {
      this.isVisibleDialog = !this.isVisibleDialog;
    },
    closeForm() {
      this.$refs.form.reset();
      this.isVisibleDialog = false;
    },
    async saveItem(item) {
      if (this.$refs.form.validate()) {
        let params = {
          ...item,
        };
        await this.$store
          .dispatch("tenantsRelationship/add", params)
          .then(() => {
            this.closeForm();
          })
          .catch((error) => {
            this.$store.dispatch("alerts/error", error.response?.data?.message);
          });
      }
    },
  },
};
</script>
